import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MilesIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.40035 8.34623C10.4941 7.4248 11.8182 6.76814 13.2739 6.475C12.8627 3.55487 10.3539 1.30835 7.32031 1.30835C3.99959 1.30835 1.30762 4.00032 1.30762 7.32104C1.30762 10.3548 3.55443 12.8638 6.47483 13.2748C6.75098 11.9027 7.35004 10.6476 8.18933 9.59203C8.0046 9.63792 7.8 9.66634 7.57556 9.67728V10.2717H7.05903V9.67021C6.70524 9.6419 6.37032 9.56407 6.05426 9.43671C5.74293 9.30462 5.46933 9.13245 5.23347 8.92017L5.79954 8.09938C6.17219 8.4343 6.59203 8.64186 7.05903 8.72205V7.81635L6.62033 7.73144C6.16276 7.65125 5.83256 7.50973 5.62972 7.30689C5.43159 7.10405 5.33253 6.81158 5.33253 6.42949C5.33253 6.13231 5.40093 5.87522 5.53773 5.65823C5.67453 5.44124 5.87265 5.27377 6.1321 5.15584C6.39154 5.0332 6.70052 4.9648 7.05903 4.95065V4.37043H7.57556V4.97187C7.86803 5.00018 8.15814 5.0615 8.44589 5.15584C8.73835 5.24547 9.00959 5.36576 9.2596 5.51671L8.7926 6.39411C8.57089 6.27146 8.35862 6.1724 8.15578 6.09693C7.95766 6.02145 7.76425 5.9672 7.57556 5.93418V6.85404L8.00719 6.9248C8.49306 7.00971 8.84685 7.15358 9.06856 7.35642C9.29498 7.55454 9.4082 7.8305 9.4082 8.18429C9.4082 8.23962 9.40558 8.2936 9.40035 8.34623ZM7.05903 6.80451V5.89173C6.85619 5.90116 6.69345 5.94598 6.5708 6.02617C6.45287 6.10164 6.3939 6.20542 6.3939 6.3375C6.3939 6.43657 6.41277 6.51912 6.45051 6.58516C6.48825 6.64648 6.54721 6.69365 6.6274 6.72667C6.71231 6.75969 6.82553 6.78328 6.96704 6.79743L7.05903 6.80451ZM7.57556 8.75743C7.79727 8.74328 7.97417 8.69611 8.10625 8.61591C8.23833 8.53572 8.30437 8.42958 8.30437 8.2975C8.30437 8.20316 8.28786 8.13004 8.25484 8.07815C8.22182 8.02155 8.15814 7.97909 8.06379 7.95079C7.97417 7.91777 7.84444 7.88946 7.67462 7.86588L7.57556 7.85173V8.75743Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.9471 7.3092C14.3926 7.3092 13.8519 7.36829 13.3309 7.48052C10.4094 8.10984 8.10916 10.4102 7.47988 13.3317C7.36767 13.8526 7.30859 14.3933 7.30859 14.9477C7.30859 19.1664 10.7285 22.5863 14.9471 22.5863C19.1658 22.5863 22.5857 19.1664 22.5857 14.9477C22.5857 10.7291 19.1658 7.3092 14.9471 7.3092ZM16.1894 13.237L14.9465 10.5607L13.7036 13.237L10.7743 13.592L12.9355 15.6011L12.3679 18.4968L14.9465 17.0622L17.5251 18.4968L16.9575 15.6011L19.1188 13.592L16.1894 13.237Z"
				fill="currentColor"
			/>
			<path
				d="M4.5 15H3.5V16.5H2L2 17.5H3.5V19H4.5V17.5H6V16.5H4.5V15Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MilesIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MilesIcon;
